import { useEffect } from 'react'

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    if (!ref?.current || typeof callback !== 'function') return

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        return callback()
      }
      return null
    }

    document.addEventListener('mousedown', handleClickOutside)

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback])
}

export default useOutsideClick
